import { useForm, Controller } from "react-hook-form";
import Cleave from "cleave.js/react";
import styles from "./Details.module.css";
import { PayWithButton } from "../../../../common/PayWithButton";
import { ButtonFooter } from "../../../../common/ButtonFooter";
import { ReactComponent as CvvCard } from "../../../../../assets/CVV-Card.svg";
import { useState } from "react";

export const Details = ({
  onPay,
  isLoading,
}: {
  onPay: () => void;
  isLoading?: boolean;
}) => {
  const { handleSubmit, control } = useForm();
  const [inputFocus, setInputFocus] = useState({
    cardNumber: false,
    cardHolder: false,
    cvv: false,
    expiryDate: false,
  });

  const [value, setValue] = useState({
    cardNumber: "",
    cvv: "",
    cardHolder: "",
    expiryDate: "",
  });

    const handleInputChange = (e: any) => {
        setValue({
            ...value,
            [e.target.id]: e.target.value,
        });
    };


    const setFocus = (e: any) => {
    e.target.placeholder = " ";
    setInputFocus({
      ...inputFocus,
      [e.target.id]: true,
    });
  };

  const setBlur = (e: any, placeholder: string) => {
    e.target.placeholder = placeholder;
    !e.target.value?.length &&
      setInputFocus({ ...inputFocus, [e.target.id]: false });
  };

  const formatCreditCardNumber = (value: any) => {
    const numericValue = value.replace(/\D/g, '');
    const formattedValue = numericValue.replace(/(\d{4})/g, '$1 ');
    return formattedValue.trim();
  };

  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit(onPay)} autoComplete="off">
        <div className={styles.form}>
          <div className={styles.cleaveInput}>
            {inputFocus.cardHolder && <label>Cardholder Name</label>}
              <Controller
                  name="cardHolder"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                      <input
                          type="text"
                          required
                          placeholder="Cardholder Name"
                          {...field}
                          id="cardHolder"
                          onFocus={setFocus}
                          onBlur={(e) => {
                              setBlur(e, "Cardholder Name");
                              field.onBlur();
                          }}
                          onChange={(e) => {
                              handleInputChange(e);
                              field.onChange(e.target.value);
                          }}
                      />
                  )}
              />

          </div>
          <div className={styles.cleaveInput}>
            {inputFocus.cardNumber && <label>Card number</label>}
            <Controller
                name="card"
                control={control}
                rules={{required: true}}
                render={({field}) => (
                    <input
                        type="text"
                        required
                        placeholder="Card number"
                        {...field}
                        id="cardNumber"
                        onFocus={setFocus}
                        onBlur={(e) => {
                          setBlur(e, "Card number");
                          field.onBlur();
                        }}
                        onChange={(e) => {
                          const formattedValue = formatCreditCardNumber(e.target.value);
                          field.onChange(formattedValue);
                        }}
                    />


                )}
            />
          </div>
          <div className={styles.dualInput}>
            <div className={styles.cleaveInput}>
              {inputFocus.expiryDate && <label>Valid till</label>}

              <Controller
                  name="exp"
                  control={control}
                  defaultValue={false}
                  rules={{required: true}}
                  render={({field}) => (
                      <Cleave
                          options={{date: true, datePattern: ["m", "y"]}}
                          type="text"
                          {...field}
                          required
                          placeholder="Valid till"
                          id="expiryDate"
                          onFocus={setFocus}
                          onBlur={(e) => {
                            setBlur(e, "Valid till");
                            field.onBlur();
                          }}
                          onChange={(e) => {
                            handleInputChange(e);
                            field.onChange(e);
                          }}
                      />
                  )}
              />
            </div>
            <div className={styles.cleaveInput}>
              {inputFocus.cvv && <label>CVV</label>}
              <Controller
                  name="cvv"
                  control={control}
                  defaultValue={false}
                  rules={{required: true}}
                  render={({field}) => (
                      <Cleave
                          options={{blocks: [3], numericOnly: true}}
                          type="text"
                          {...field}
                          required
                          placeholder="CVV"
                          id="cvv"
                          onFocus={setFocus}
                          onBlur={(e) => {
                            setBlur(e, "CVV");
                            field.onBlur();
                          }}
                          onChange={(e) => {
                            handleInputChange(e);
                            field.onChange(e);
                          }}
                      />
                  )}
              />
              <CvvCard/>
            </div>
          </div>
        </div>
        <ButtonFooter>
          <PayWithButton
              isDisabled={
                  !value?.cvv?.length ||
                  !value?.expiryDate?.length
              }
              isLoading={isLoading}
          />
        </ButtonFooter>
      </form>
    </div>
  );
};
